export const iconFontAwesomeChartsDiagramsDiagramProject = (
	<i className="fa-solid fa-diagram-project"></i>
);
